import $ from "jquery";
import Storage from "@bd-utils/storage";
import { getCurrentPageId } from "@bd-stores/user-progress";

export default class ChallengeAudio {
    constructor() {
        this.elms = {
            audio: ".js-audio-challenge",
        };

        this.roomId = false;

        this;

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.audioChallenge) states.audioChallenge = [];
        states.audioChallenge.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.audioChallenge && states.audioChallenge.includes(roomId);
    }

    init(roomId, isAutoPlay = false) {
        this.roomId = roomId;

        const $audio = $(this.elms.audio);

        if (!$audio.length) return;

        if (this._getHasSeen(roomId)) return;

        if ($(this.elms.audio).hasClass("is-played")) return;

        if (isAutoPlay) {
            this.playAudio();
        }
    }

    playAudio() {
        const $audio = $(this.elms.audio);
        const currentPageId = getCurrentPageId();

        if (!$audio.length) return;

        const $audioFIle = $audio.get(0);

        $audioFIle.oncanplay = () => {
            // @ts-ignore
            $audioFIle.play();

            setTimeout(() => {
                // @ts-ignore
                const played = $audioFIle.currentTime;

                if (played) {
                    $audio.addClass("is-played");

                    this._setHasSeen(currentPageId);
                }
            }, 500);
        };
    }
}
